import React from 'react';
import { motion } from 'framer-motion';
import { Calculator, AlertCircle } from 'lucide-react';
export function CostOfInaction() {
  const costs = [{
    sin: '3 hs de planificación de contenido × 48 semanas',
    costo: '144 horas de tu vida por año'
  }, {
    sin: 'Responder las mismas consultas una y otra vez',
    costo: '10 horas semanales regaladas'
  }, {
    sin: 'No tener seguimiento de clientes',
    costo: 'Ventas perdidas todos los meses'
  }, {
    sin: 'Precios sin calcular bien el margen',
    costo: 'Trabajás para cubrir costos sin saberlo'
  }, {
    sin: 'Sin automatizaciones de WhatsApp',
    costo: 'Clientes que se van a la competencia que sí responde'
  }, {
    sin: 'El lunes siguiente sin sistema',
    costo: 'El mismo ciclo, el próximo año'
  }];
  return <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-5xl mx-auto" data-id="element-50">
      <div className="text-center mb-12" data-id="element-51">
        <h2 className="text-3xl font-bold text-white mb-4 flex items-center justify-center gap-3" data-id="element-52">
          <AlertCircle className="text-brand-red w-8 h-8" data-id="element-53" />
          ⚖️ ¿Cuánto cuesta NO tenerlo?
        </h2>
      </div>

      <div className="overflow-x-auto mb-12 rounded-2xl border border-white/10" data-id="element-54">
        <table className="w-full text-left border-collapse" data-id="element-55">
          <thead data-id="element-56">
            <tr className="bg-white/5" data-id="element-57">
              <th className="p-4 border-b border-white/10 text-gray-300 font-medium" data-id="element-58">
                Sin Megapack
              </th>
              <th className="p-4 border-b border-white/10 text-brand-red font-bold" data-id="element-59">
                Costo real
              </th>
            </tr>
          </thead>
          <tbody data-id="element-60">
            {costs.map((row, i) => <tr key={i} className="border-b border-white/5 hover:bg-white/5 transition-colors" data-id="element-61">
                <td className="p-4 text-gray-300" data-id="element-62">{row.sin}</td>
                <td className="p-4 text-brand-red font-medium" data-id="element-63">{row.costo}</td>
              </tr>)}
          </tbody>
        </table>
      </div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="bg-red-950/30 border border-brand-red/30 rounded-3xl p-8 md:p-10 max-w-3xl mx-auto mb-16 relative overflow-hidden" data-id="element-64">
        <div className="absolute top-0 left-0 w-full h-1 bg-brand-red" data-id="element-65" />
        <div className="flex items-center gap-3 mb-6" data-id="element-66">
          <Calculator className="w-6 h-6 text-brand-red" data-id="element-67" />
          <h3 className="text-2xl font-bold text-white" data-id="element-68">La cuenta que duele</h3>
        </div>

        <div className="space-y-4 text-gray-300 font-mono text-sm md:text-base bg-black/40 p-6 rounded-xl border border-white/5" data-id="element-69">
          <p data-id="element-70">CALCULÁ EL COSTO REAL:</p>
          <p data-id="element-71">
            Tu valor hora:{' '}
            <span className="text-white bg-white/10 px-2 py-1 rounded" data-id="element-72">
              $[LO QUE VALE TU HORA]
            </span>
          </p>
          <p data-id="element-73">Horas semanales en tareas automatizables:</p>
          <p className="text-brand-red font-bold" data-id="element-74">
            ~15 horas/semana (promedio de nuestros compradores)
          </p>
          <div className="h-px bg-white/10 my-4" data-id="element-75" />
          <p data-id="element-76">
            Costo mensual de no automatizar: 15 hs × 4 semanas × $[VALOR HORA] ={' '}
            <span className="text-white font-bold" data-id="element-77">$[TOTAL]/mes</span>
          </p>
          <p data-id="element-78">
            Costo anual: $[TOTAL]/mes × 12 ={' '}
            <span className="text-brand-red font-bold" data-id="element-79">$[TOTAL]/año</span>
          </p>
          <div className="h-px bg-white/10 my-4" data-id="element-80" />
          <p className="text-lg text-white font-bold text-center" data-id="element-81">
            EL MEGAPACK CUESTA $19.990. ¿CUÁNTO TE CUESTA NO TENERLO?
          </p>
        </div>
      </motion.div>

      <div className="text-center max-w-3xl mx-auto" data-id="element-82">
        <h3 className="text-2xl font-bold text-white mb-8" data-id="element-83">
          El lunes que viene puede ser diferente.
        </h3>
        <blockquote className="text-xl text-gray-300 italic border-l-4 border-brand-violet pl-6 text-left" data-id="element-84">
          "La IA no te va a quitar el trabajo. Pero el emprendedor que use IA le
          va a quitar los clientes al que no la use."
          <footer className="text-brand-violet font-bold text-sm mt-4 not-italic" data-id="element-85">
            — Equipo AURA BIT
          </footer>
        </blockquote>
      </div>
    </section>;
}